import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, ReplaySubject } from 'rxjs';
import { Store, select } from '@ngrx/store';

import { NewMessageDialogComponent } from 'src/app/shared/components/new-message-dialog/new-message-dialog.component';
import { Router } from '@angular/router';
import { HomeProfileService } from './store/info.service';
import { ProfileState, selectProfileInfo } from './store/info.reducer';
import { loadProfileInfoById, loadProfileInfo } from './store/info.actions';
import { AuthService } from '../../../core/services/auth.service';
import { map, takeUntil, filter, tap, delay, timeout } from 'rxjs/operators';
import { Dialog } from 'src/app/core/services/dialogs/dialog.model';
import { ConvertIdService } from '../../../core/services/convert-id.service';

import {
  addContact,
  removeContact
} from 'src/app/core/services/contacts/contacts.actions';
import { SocketService } from 'src/app/core/services/socket.service';

@Component({
  selector: 'app-profile-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.scss']
})
export class ProfileInfoComponent implements OnChanges {
  @Input() userId: string;

  hideInfo = false;
  profileInfo: any;
  profileInfo$: Observable<any>;
  isShowConnectMessage$ = this.auth.user$.pipe(
    filter((val) => !!val),
    map(
      (user) => this.converter.convertIdNumberToString(user.id) !== this.userId
    )
  );

  dialogs: Dialog[];

  destroy: ReplaySubject<any> = new ReplaySubject<any>(1);

  constructor(
    private store: Store<ProfileState>,
    private dialog: MatDialog,
    private router: Router,
    private auth: AuthService,
    private snackBar: MatSnackBar,
    private converter: ConvertIdService,
    private readonly _socketService: SocketService
  ) {
    this.profileInfo$ = store.pipe(
      select(selectProfileInfo),
      takeUntil(this.destroy)
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.userId && this.userId) {
      this.store.dispatch(loadProfileInfoById({ profileId: this.userId }));
    } else {
      this.store.dispatch(loadProfileInfo());
    }
  }

  // async openMessageDialog() {
  //   this.dialog.open(NewMessageDialogComponent, {
  //     panelClass: 'rp-dialog',
  //     data: this.profileInfo,
  //   });
  // }

  openMessageDialog(profileInfo) {
    const contact = profileInfo;
    const receiverID = contact.dialog_id || null;

    const dialogRef = this.dialog.open(NewMessageDialogComponent, {
      data: { contact, receiverID }
    });

    dialogRef
      .afterClosed()
      .pipe(
        takeUntil(this.destroy),
        filter((_) => _?.isSend && _?.message),
        map(({ message }): any => message)
      )
      .subscribe((message: string) => this.sendMessage(contact.id, message));
  }

  private sendMessage(userID: number, text: string) {
    this._socketService.sendMessage(userID, text, null, null);
    this.messageHasBeenSent();
  }

  private messageHasBeenSent() {
    this.snackBar.open('Message has been sent!', 'OK', {
      duration: 10 * 1000
    });
  }

  public searchByTopic(e: Event, topic: string, value: string) {
    e.preventDefault();
    window.scrollTo(0, 0);

    this.router.navigate([`/search`], {
      queryParams: {
        q: value
      }
    });
  }

  onProfileConnect(id: number) {
    this.store.dispatch(addContact({ id }));
  }

  onProfileDisconnect(id: number) {
    this.store.dispatch(removeContact({ id }));
  }
}
